module.exports = __webpack_public_path__ + "TextaNarrow-Regular-webfont.2ea72b85913cba4a5101.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Regular-webfont.woff2
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Regular-webfont.woff2
// module chunks = styles